module.exports = __webpack_public_path__ + "static/media/LambdaSchoolWhite.267094cf.svg";